import type { Round } from "@roman/shared/types/Round";
import { cn } from "@roman/shared/utils";
import { RoundInfoFooter } from "./components/RoundInfoFooter";

type RoundCardProps = {
  round: Round;
  onClick: () => void;
  showFooter?: boolean;
  isRounded?: boolean;
};

export const RoundCard = ({ round, onClick, showFooter = true, isRounded = true }: RoundCardProps) => {
  const isFullEntry = round.numEntries >= round.maxNumEntries;

  return (
    <div
      className={cn(
        "relative p-1 flex min-w-[250px] flex-col bg-white rounded-lg text-base w-full shadow-[3.789px_3.789px_3.789px_0px_rgba(23,107,242,0.10)] cursor-pointer",
      )}
    >
      <div className={cn(isFullEntry ? "opacity-20" : "opacity-100")}>
        <div className={cn("w-full ", isRounded ? "rounded-sm" : "")}>
          <img
            onClick={onClick}
            src={round.imageUrl || "/assets/card-bg-sample.png"}
            alt="round-image"
            className={cn("object-contain aspect-[16/9] w-full", isRounded ? "rounded-[10px]" : "")}
            draggable={false}
          />
        </div>
        {showFooter && <RoundInfoFooter onClick={onClick} round={round} />}
      </div>

      {isFullEntry && (
        <div className="absolute top-[74px] bottom-[153.47px] left-20 right-20 z-10 flex justify-center items-center">
          <img src={"/assets/full-entry.png"} alt="Full entry indicator" draggable={false} />
        </div>
      )}
    </div>
  );
};
